<template>
  <div class="st-select">
    <van-popup v-model:show="showPicker" round position="bottom" :close-on-click-overlay="false">
      <div v-if="filterable && !readonly && optionsType == 'function'" style="height: 60px;overflow: hidden;">
        <div style="float: left;left: 50%;top: 50%;position:relative;transform: translate(-50%, -50%);width: 95%;">
          <div style="float: left;position: relative;width: 100%;">
            <van-field
              v-model="query"
              name="筛选"
              label=""
              placeholder="筛选"
              @input="getInputData"
            />
          </div>
        </div>
      </div>
      <van-picker
        v-loading="pickerLoading"
        show-toolbar
        :columns="myOptions"
        @cancel="pickerCancel"
        @confirm="pickerConfirm"
        ref="picker"
        @change="pickerChange"
        :default-index="pickerVal"
      />
      
      <div style="text-align: center;height: 50px;line-height: 50px;" v-if="!readonly && optionsType == 'function' && filterable">
        <span v-if="!loadFinish" @click="loadMore">加载更多</span>
        <span v-else>已经到底了</span>
      </div>
    </van-popup>
    <div :data-readonly="readonly ? 1 : 0" style="position: relative;">
      <van-field
        class="st-form-item-input"
        ref="select-input"
        is-link
        v-model="text"
        :name="name"
        :label="fieldLable"
        :placeholder="placeholder"
        @click="onClick"
        readonly
				clearable
      />
			<div @click="clearVal" v-if="val && clearable" style="display: inline-block;position: absolute;top: 10px;right: 40px;font-size: 20px;color: #f1b9b9;"><van-icon name="close" /></div>
			
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    defText: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    options: {
      type: [Array, Function],
      default: () => {
        return [];
      }
    },
    name: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    label: {
      type: [String, Number],
      default: () => {
        return '';
      }
    },
    placeholder: {
      type: String,
      default: () => {
        return '';
      }
    },
    readonly: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
		clearable: {
		  type: Boolean,
		  default: () => {
		    return false;
		  }
		},
		valField: {
			type: String,
			default: () => {
				return '';
			}
		},
		
		customParams: {
			type: Object,
			default: () => {
				return {}
			}
		},
		filterable: {
			type: Boolean,
			default: () => {
				return true;
			}
		},
		fieldLable: {
			type: String,
			default: () => {
				return '';
			}
		},
		clickBefore: {
			type: Function,
			default: null,
		}

  },
  data() {
    return {
      pickerLoading: false,
      myOptions: [],
      showPicker: false,
      val: this.value,
      text: this.defText,
      query: '',
      loadFinish: false,
      page: 1,
      optionsType: 'string',
      searchTimeOut: null,
      pickerVal: 0,
    };
  },
  created() {
    this.init();
    setTimeout(() => {
      this.$watch('value', (newV, oldV) => {
        if (newV !== oldV) {
          this.val = newV;
          this.setText();
        }
      });

      this.$watch('text', (newV, oldV) => {
        if (newV !== oldV) {
          this.$emit('changeText', this.text);
        }
      });
			
			// 筛选参数变更 重头来
			this.$watch('customParams', (newV, oldV) => {
				if (JSON.stringify(newV) !== JSON.stringify(oldV)) {
					 this.filterFromApi();
				}
			}, { deep: true });
    }, 0)
  },
  mounted() {
  },
  watch: {},
  methods: {
    init() {
      this.optionsType = typeof this.options;
      if (this.optionsType == 'function') {
        this.loadMore();
      } else {
        this.myOptions = this.options;
      }
      this.setText();
    },
    // 设置要显示的文本
    setText() {
      let exist = this.myOptions.find((item) => {  
        return item.value === this.val; 
      });

      if (exist) {
        this.text = exist.text;
      } else if (this.val === '') {
        this.text = '';
      } else {
        this.text = this.defText;
      }

      
    },
    // 点击输入框
    onClick() {
			let exc = true;
			// 点击
			if (this.clickBefore) {
				exc = this.clickBefore();
			}
			if (exc) {
				this.showPicker = true;
				this.$emit('click');
			}
      
    },
		
		clearVal() {
			this.val = '';
			this.text = '';
			this.$emit('input', this.val);
			this.$emit('change', this.val, this.text)
		},
    // 选择确定提交
    pickerConfirm(obj, ind) {
      this.text = obj.text !== undefined ? obj.text : obj.value;
      this.val = obj.value;
      this.$emit('input', this.val);
			this.$emit('change', this.val, this.text)

      // 触发input blur 事件
      this.emitInputBlur();
      this.showPicker = false;
    },

    // 触发input blur 事件
    emitInputBlur() {
      this.$nextTick(() => {
        let ele = this.$refs['select-input'].$el.querySelector('input');
        ele.focus();
        ele.blur();
      })
    },

    // 取消选择
    pickerCancel() {
      this.showPicker = false;
      // 触发input blur 事件
      this.emitInputBlur();
    },

    // picker change 事件
    pickerChange(event, obj, i) {
      // 如果 是最后一个 且 还没到底  就要加载更多
      if (i === this.myOptions.length - 1 && !this.loadFinish && typeof this.options === 'function' ) {
        this.loadMore();
      }
    },

    // 筛选 input 事件
    getInputData(val) {
      this.myOptions = [];
      this.pickerLoading = true;
      // 如果已经有了 则终结
      if (this.searchTimeOut) {
        clearTimeout(this.searchTimeOut);
      }
      // 延迟2秒后执行
      this.searchTimeOut = setTimeout(() => {
        this.filterFromApi(val);
        clearTimeout(this.searchTimeOut);
        this.pickerLoading = false;
      }, 2000);
    },
    
    // 加载更多
    loadMore() {
      let params = { page: this.page, query: this.query };
      let res =  this.options(this, params);
      let options = [];
      if (res.then) {
        res.then((data) => { 
          if (data.length <= 0) {
            this.loadFinish = true;
          }
        
          if (this.page > 1) {
            // 加载更多时 picker的值会变为0，这样会使得picker 直接滚动到顶部，而不是当前的位置，所以需要手动设置一下
            let curVal = this.$refs.picker.getValues()[0];
            let pickIndex = this.myOptions.findIndex((item) => { return item.value === curVal.value; });
            this.myOptions.push(...data);
            this.pickerVal = pickIndex;
          } else {
            this.myOptions.push(...data);
          }
          
          this.setText();
          // 由于没有使用同步 指令，page如果放在then后面会先++，然后判断时候不准确，导致报错
          this.page++;
        })
      } else {
        this.myOptions.push(...res);
        this.page++;
      }
      
    },

    // 通过api  进行 筛选
    filterFromApi(query) {
      this.page = 1;
      this.query = query;
      this.myOptions = [];
			this.loadFinish = false;
      this.loadMore();
    },

  },
};
</script>

<style lang="scss" scoped>
.st-select {
  .van-field {
    box-shadow: inset 0 0 0 2px rgb(223,223,223);
    border-radius: 5px;
  }

  div[data-readonly='1'] .van-field{
    background-color: rgba(233, 233, 233, 1);
  }
}
</style>
